import {Component, computed, inject, linkedSignal, model, output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {OrderStore} from '../../../../shared/store/order.store';
import {AppStore} from '../../../../shared/store/app.store';
import {Modal} from '../../../../shared/components/modal/modal';
import {ButtonComponent} from '../../../../shared/components/button/button.component';
import {Alert} from '../../../../shared/components/alert/alert';
import {DynamicFieldFormComponent} from '../../../../shared/components/dynamic-field-form/dynamic-field-form';

@Component({
  selector: 'app-vendor-order-fields-modal',
  imports: [Modal, ButtonComponent, Alert, DynamicFieldFormComponent, FormsModule],
  templateUrl: './vendor-order-fields-modal.component.html',
  styleUrl: './vendor-order-fields-modal.component.css',
})
export class VendorOrderFieldsModalComponent {
  isOpen = model<boolean>(false);

  cancelled = output<void>();
  submitted = output<void>();

  orderStore = inject(OrderStore);
  private appStore = inject(AppStore);

  // Previously entered values win so going back to a vendor keeps what was typed
  formValues = linkedSignal<Record<string, any>>(() => {
    const vendor = this.orderStore.activeVendor();
    if (!vendor) return {};

    const existing = this.appStore.getSetting()(`${vendor.key}_default_order_field_values`);
    return {...(existing?.value ?? {}), ...(this.orderStore.orderFields()[vendor.key] ?? {})};
  });

  submittedVendorNames = computed(() =>
    this.orderStore.submittedVendorKeys().map(key => this.orderStore.vendors()[key]?.name ?? key).join(', ')
  );

  onClose() {
    this.formValues.set({});
    this.cancelled.emit();
  }

  submit() {
    const vendor = this.orderStore.activeVendor();
    if (!vendor) return;

    this.orderStore.saveVendorFields(vendor.key, this.formValues());
    this.submitted.emit();
  }
}
